<template>
  <div :class="$style.container" class="j_filter_other">
    <!-- <div :class="$style.header">
      <h3 :class="$style.title">国家</h3>
    </div> -->

    <div :class="$style.body">
      <!-- <el-scrollbar :wrap-class="$style.scroller"> -->
        <index-block title="吨位范围（吨）">
          <div :class="$style.checkboxGroup" class="1.5">
            <el-checkbox v-model="state.tonnage" v-for="tonnage in tonnageOptions" :key="tonnage.key" :class="$style.checkboxItem"
              :label="tonnage.key">
              <span class="ml-1 text-sm">{{tonnage.val}}</span>
            </el-checkbox>
          </div>
        </index-block>
        <index-block title="翻新时间">
          <el-date-picker class="mt-5" value-format="yyyy-MM-dd" size="medium" v-model="renovationTime" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :appendToBody="false" />
        </index-block>
        <index-block title="首航时间">
          <el-date-picker class="mt-5" value-format="yyyy-MM-dd" size="medium" v-model="firstFlightTime" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :appendToBody="false" />
        </index-block>
      <!-- </el-scrollbar> -->
    </div>
    <div :class="$style.footer">
      <button class="text-dark transition-colors hover:text-primary" @click="onReset"> <i class="el-icon-refresh-right" /> <span>重置</span></button>

      <div class="ml-auto">
        <el-button @click="$emit('close')">取消</el-button>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
	defineComponent,
	// ref,
	computed,
	useStore,
	// unref,
	reactive,
	watch,
	watchEffect
} from "@nuxtjs/composition-api";
import { isEmpty, pick } from "lodash";
import IndexBlock from "./index-block.vue";
export default defineComponent({
	name: "IndexFilterStatus",
	components: { IndexBlock },
	props: {
		defaultData: {
			type: Object,
			default: () => ({
				tonnage: [],
				renovation_time_start: "",
				renovation_time_end: "",
				first_flight_time_start: "",
				first_flight_time_end: ""
			})
		}
	},
	emits: ["confirm", "close"],
	setup(props, { emit }) {
		const store = useStore();
		const state = reactive({
			tonnage: [],
			renovation_time_start: "",
			renovation_time_end: "",
			first_flight_time_start: "",
			first_flight_time_end: ""
		});

		watchEffect(() => {
			Object.assign(state, {...props.defaultData});
		});
		// const checkedTonnage = ref([]);
		const tonnageOptions = computed(() => {
			return store.state.cruiseMap.filterData.tonnage.map((item) => ({
				...item,
				key: [item.min, item.max].join("-")
			}));
		});
		const renovationTime = computed({
			get() {
				return [state.renovation_time_start, state.renovation_time_end];
			},
			set(value) {
				if (isEmpty(value)) {
					value = ["", ""];
				}
				[state.renovation_time_start, state.renovation_time_end] = value;
			}
		});
		const firstFlightTime = computed({
			get() {
				return [state.first_flight_time_start, state.first_flight_time_end];
			},
			set(value) {
				if (isEmpty(value)) {
					value = ["", ""];
				}
				[state.first_flight_time_start, state.first_flight_time_end] = value;
			}
		});

		function onReset() {
			Object.assign(state, {
				tonnage: [],
				renovation_time_start: "",
				renovation_time_end: "",
				first_flight_time_start: "",
				first_flight_time_end: ""
			});
		}

		function onConfirm() {
			emit("confirm", { ...state });
		}


		// const pickerOptions = reactive({
		// 	boundariesElement: '.j_filter_other'
		// })
		return {
			state,
			tonnageOptions,
			// pickerOptions,

			renovationTime,
			firstFlightTime,

			onReset,
			onConfirm
		};
	}
});
</script>
<style lang="scss" module>
.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  max-height: 25rem;
  padding: 1.5rem;
}
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.title {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.scroller {
  max-height: 23rem;
}
.footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-top: 0.625rem;
}
.checkboxGroup {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.checkboxItem {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-top: 0.875rem;
  margin-bottom: 0.875rem;
  margin-left: 0px;
  margin-right: 0px;
  width: 25%;
}
</style>